import React from 'react';
import PropTypes from 'prop-types';

import VendorRelationTable from './vendor_relation_table';

export default function QuickbooksBrokerVendorTable({ brokers }) {
  if (brokers.length === 0) {
    return <p>No brokers found for this company.</p>;
  }

  return (
    <VendorRelationTable relationType="Broker" showAll={true} users={brokers} vendorFetchType="broker" />
  );
}

QuickbooksBrokerVendorTable.propTypes = {
  brokers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    quickbooksId: PropTypes.number,
  })).isRequired,
};